export const LAST_5_MINUTES = 0;
export const LAST_15_MINUTES = 1;
export const LAST_30_MINUTES = 2;
export const LAST_HOUR = 3;
export const LAST_3_HOURS = 4;
export const LAST_6_HOURS = 5;
export const LAST_12_HOURS = 6;
export const LAST_24_HOURS = 7;
export const LAST_WEEK = 8;
export const LAST_MONTH = 9;
export const LAST_YEAR = 10;
export const TIME_RANGE_QUICK = 11;
export const TIME_RANGE_ABSOLUTE = 12;
